module.exports = __webpack_public_path__ + "static/media/DSC_0088.b0d5d49d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/people/DSC_0088.jpg
// module id = 629
// module chunks = 0